import { SAFEBUY_INTERNAL_API_PATHS } from "@constants/safebuy-users/api-paths";

export function createSafebuyApiUrl(
  endpoint: keyof typeof SAFEBUY_INTERNAL_API_PATHS
): string {
  return SAFEBUY_INTERNAL_API_PATHS[endpoint];
}

export function createOrdersListUrl(): string {
  return createSafebuyApiUrl("ORDERS_LIST");
}

export function createMerchantsListUrl(): string {
  return createSafebuyApiUrl("MERCHANTS_LIST");
}

export function createMerchantProfileUrl(merchantId: string): string {
  return `${createSafebuyApiUrl("MERCHANT_PROFILE")}/${merchantId}`;
}

export function createOrderDetailUrl(orderId: string): string {
  return `${createSafebuyApiUrl("ORDER_DETAIL")}/${orderId}`;
}

export function createFAQUrl(orderId?: string): string {
  const baseUrl = createSafebuyApiUrl("FAQ_COMMON");
  return orderId ? `${baseUrl}?order_id=${orderId}` : baseUrl;
}

export function createPayoutUrl(): string {
  return createSafebuyApiUrl("PAYOUT");
}
